import * as types from '@/redux/actionTypes';

const initState = {
  loading: false,
  listLoading: false,
  entities: {},
  setting: {},
  applyForm: {},
  overseasNumberSetting: {},
};

function org(state = initState, { type, payload }) {
  switch (type) {
    case types.LOAD_ORG: {
      return {
        ...state,
        loading: payload,
      };
    }

    case types.LOAD_ORG_LIST: {
      return {
        ...state,
        listLoading: payload,
      };
    }

    case types.UPDATE_ORG: {
      const entities = { ...state.entities };
      if (payload.org) {
        entities[payload.org.id] = { ...entities[payload.org.id], ...payload.org };
      }
      return {
        ...state,
        entities,
      };
    }

    case types.UPDATE_ORG_LIST: {
      payload.orgList = payload.orgList || [];
      const entities = state.entities;
      const newEntities = payload.orgList.reduce((_entities, job) => {
        _entities[job.id] = { ...job, ...(entities[job.id] || {}) };
        return _entities;
      }, {});
      return {
        ...state,
        entities: newEntities,
      };
    }

    case types.ADD_APPLICATION_NUM: {
      const { orgId, numAdded } = payload;
      const entities = { ...state.entities };
      if (entities[orgId]) {
        entities[orgId].applicationNum += numAdded;
      }
      return {
        ...state,
        entities,
      };
    }

    case types.UPDATE_HEADHUNTER_SETTING: {
      const { setting } = payload;
      return {
        ...state,
        setting,
      };
    }

    case types.UPDATE_HEADHUNTER_APPLY_FORM: {
      const { applyForm } = payload;
      return {
        ...state,
        applyForm,
      };
    }

    case types.UPDATE_OVERSEAS_NUMBER_SETTING: {
      const { overseasNumberSetting } = payload;
      return {
        ...state,
        overseasNumberSetting,
      };
    }

    default:
      return state;
  }
}

export default org;
